<template>
    <section id="como-funciona" class="sp-section sp-como-funciona">
        <!-- Orbe de luz ambiental -->
        <div class="sp-glow-orb sp-glow-orb--orange" style="top: 35%; right: -5%; width: 420px; height: 420px;"></div>

        <div class="sp-container">
            <div class="sp-section-head sp-reveal">
                <span class="sp-eyebrow">Así de fácil</span>
                <h2 class="sp-h2">Empieza a anunciarte en 4 sencillos pasos</h2>
                <p class="sp-lead">
                    Del registro a tu primera oferta visible para miles de conductores que ya circulan
                    cerca de tu sede.
                </p>
            </div>

            <ol class="sp-pasos">
                <li v-for="(paso, i) in pasos" :key="paso.titulo" class="sp-paso sp-reveal" :class="'sp-delay-' + (i + 1)">
                    <div class="sp-paso__card">
                        <div class="sp-paso__marca">
                            <span class="sp-paso__num">{{ i + 1 }}</span>
                            <span class="sp-paso__icon">
                                <i :class="'pi ' + paso.icon" aria-hidden="true"></i>
                            </span>
                        </div>
                        <h3 class="sp-h3">{{ paso.titulo }}</h3>
                        <p>{{ paso.texto }}</p>
                    </div>
                </li>
            </ol>

            <!-- Nota de cobertura -->
            <div class="sp-nota sp-reveal sp-delay-4">
                <div class="sp-nota__icon">
                    <i class="pi pi-shield" aria-hidden="true"></i>
                </div>
                <div>
                    <strong>Cobertura inteligente:</strong>
                    <span>
                        El área de cobertura de cada sede la define Seway al momento de activarla,
                        asegurando que las ofertas lleguen en el momento más seguro y oportuno del viaje.
                    </span>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'NegociosComoFunciona',
    data() {
        return {
            pasos: [
                {
                    icon: 'pi-user-plus',
                    titulo: 'Regístrate',
                    texto: 'Crea tu cuenta de anunciante y registra la información básica de tu negocio.'
                },
                {
                    icon: 'pi-image',
                    titulo: 'Crea tu oferta',
                    texto: 'Agrega fotos atractivas, descripción, porcentaje de descuento y horarios de atención.'
                },
                {
                    icon: 'pi-calendar',
                    titulo: 'Elige tu campaña',
                    texto: 'Selecciona la duración por días y el nivel de visibilidad deseado.'
                },
                {
                    icon: 'pi-map-marker',
                    titulo: '¡Aparece en Seway!',
                    texto: 'Tu oferta se muestra automáticamente a los conductores en ruta.'
                }
            ]
        };
    }
};
</script>

<style lang="scss" scoped>
.sp-como-funciona {
    position: relative;
    overflow: hidden;
}

.sp-pasos {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem 1.5rem;
    margin: 0;
    padding: 0;
    list-style: none;
}

.sp-paso {
    position: relative;
}

.sp-paso__card {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 2rem 1.5rem;
    background: #ffffff;
    border: 1px solid var(--sp-border);
    border-radius: var(--sp-radius-lg);
    box-shadow: var(--sp-shadow-sm);
    transition: transform var(--sp-transition-normal), box-shadow var(--sp-transition-normal), border-color var(--sp-transition-normal);

    &:hover {
        transform: translateY(-6px);
        border-color: rgba(235, 93, 27, 0.4);
        box-shadow: 0 16px 36px rgba(13, 48, 68, 0.1);

        .sp-paso__icon {
            background: linear-gradient(135deg, var(--sp-orange) 0%, #ff7536 100%);
            color: #fff;
            border-color: transparent;
            box-shadow: 0 8px 22px rgba(235, 93, 27, 0.4);
            transform: scale(1.08);
        }

        .sp-paso__num {
            transform: scale(1.15);
        }
    }

    h3 {
        margin-top: 1.25rem;
    }

    p {
        margin-top: 0.5rem;
        color: var(--sp-text-soft);
        font-size: 0.94rem;
        line-height: 1.6;
    }
}

.sp-paso__marca {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.sp-paso__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 4.6rem;
    height: 4.6rem;
    background: var(--sp-surface-alt);
    border: 2px solid var(--sp-border);
    border-radius: 50%;
    color: var(--sp-navy);
    font-size: 1.7rem;
    transition: all 0.3s cubic-bezier(0.25, 1, 0.5, 1);
}

.sp-paso__num {
    position: absolute;
    top: -0.35rem;
    left: -0.45rem;
    z-index: 2;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.2rem;
    height: 2.2rem;
    background: linear-gradient(135deg, var(--sp-orange) 0%, var(--sp-orange-600) 100%);
    border: 3px solid #fff;
    border-radius: 50%;
    color: #fff;
    font-size: 0.95rem;
    font-weight: 800;
    box-shadow: 0 3px 10px rgba(235, 93, 27, 0.4);
    transition: transform 0.25s ease;
}

.sp-nota {
    display: flex;
    align-items: center;
    gap: 1rem;
    max-width: 820px;
    margin: clamp(2.5rem, 5vw, 3.5rem) auto 0;
    padding: 1.25rem 1.75rem;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(235, 93, 27, 0.25);
    border-radius: 14px;
    box-shadow: 0 8px 24px rgba(13, 48, 68, 0.06);
    color: var(--sp-navy);
    font-size: 0.94rem;
    line-height: 1.6;

    strong {
        color: var(--sp-orange);
        margin-right: 0.35rem;
    }
}

.sp-nota__icon {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.8rem;
    height: 2.8rem;
    background: var(--sp-orange-50);
    border-radius: 10px;
    color: var(--sp-orange);
    font-size: 1.3rem;
}

@media (min-width: 576px) {
    .sp-pasos {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (min-width: 992px) {
    .sp-pasos {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
}
</style>
